import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from '@/store'
import jwtUtil from '@/utils/jwtUtil'

const COMPANY_NAME = process.env.VUE_APP_ENV_COMPANY_NAME
Vue.config.productionTip = false

Vue.mixin({
    computed: {
        isAdminOrCompanyCoordinator() {
            const token = this.$store.getters.getToken
            if (!token) return false
            const userRoles = jwtUtil.getRoles(token)
            const containsAny = (arr1, arr2) => arr1.some(item => arr2.includes(item))
            const userContractor = this.$store.getters.getUserContractor || ''
            return containsAny(['ROLE_ADMIN'], userRoles) ||
                (containsAny(['ROLE_COORDINATOR'], userRoles) && userContractor.toLowerCase() === COMPANY_NAME.toLowerCase())
        },
        isAdmin() {
            const token = this.$store.getters.getToken
            if (!token) return false
            const userRoles = jwtUtil.getRoles(token)
            const containsAny = (arr1, arr2) => arr1.some(item => arr2.includes(item))
            return containsAny(['ROLE_ADMIN'], userRoles)
        },
        isCoordinator() {
            const token = this.$store.getters.getToken
            if (!token) return false
            const userRoles = jwtUtil.getRoles(token)
            const containsAny = (arr1, arr2) => arr1.some(item => arr2.includes(item))
            return containsAny(['ROLE_COORDINATOR'], userRoles)
        },
        isCompanyWelder() {
            const token = this.$store.getters.getToken
            if (!token) return false
            const userRoles = jwtUtil.getRoles(token)
            const containsAny = (arr1, arr2) => arr1.some(item => arr2.includes(item))
            const userContractor = this.$store.getters.getUserContractor || ''
            console.log(userRoles)
            console.log(userContractor)
            return containsAny(['ROLE_WELDER'], userRoles) && userContractor.toLowerCase() === COMPANY_NAME.toLowerCase()
        },
        isCompanyBlower() {
            const token = this.$store.getters.getToken
            if (!token) return false
            const userRoles = jwtUtil.getRoles(token)
            const containsAny = (arr1, arr2) => arr1.some(item => arr2.includes(item))
            const userContractor = this.$store.getters.getUserContractor || ''
            return containsAny(['ROLE_BLOWER'], userRoles) && userContractor.toLowerCase() === COMPANY_NAME.toLowerCase()
        }
    }
})
new Vue({
    vuetify,
    router,
    store,
    render: h => h(App)
}).$mount('#app')
